module.exports = __webpack_public_path__ + "media/images/pasta-417d6a195859aa9b051a179044e1966c.png";